function disableMainScroll() {
  if (window.innerWidth < 1024) {
    document.body.classList.add("remove-scrolling");
  }
}

function enableMainScroll() {
  document.body.classList.remove("remove-scrolling");
}
function initializeNavbar() {
  const header = document.querySelector(".site-header");
  const menuWrapper = document.querySelector(".navbar__menu-wrapper");
  const menuTrigger = document.querySelector(".navbar__menu-trigger");
  const subMenuTriggers = document.querySelectorAll(
    ".menu-item-has-children > a"
  );
  const closeButton = document.querySelector(".navbar__menu-close-button");
  const closeSubMenuButton = document.querySelector(
    ".navbar__close-sub-menu-trigger"
  );

  const searchMenuWrapper = document.querySelector(".navbar__search");
  const searchTrigger = document.querySelector(".navbar__search-trigger");
  const searchCloseButton = document.querySelector(
    ".navbar__search-close-button"
  );
  const searchForm = document.querySelector(".navbar__search-form");
  const navbarContainer = document.querySelector(".navbar__container");

  const bookNowButton = document.getElementById("navbar__book-now-button");
  const bookNowButtonMobile = document.querySelector(
    ".navbar__mobile-book-button"
  );

  if (!menuWrapper || !navbarContainer) {
    return;
  }

  const navbarTabButtons = document.querySelectorAll(".navbar__tab button");
  const navbarTabs = document.querySelectorAll(".navbar__tab-content");
  const navbarTabThumb = document.querySelector(
    ".navbar__tab-navigation-thumb"
  );

  const setTabThumbWidth = (button) => {
    if (navbarTabButtons.length && navbarTabThumb) {
      navbarTabThumb.style.width = `${button.getBoundingClientRect().width}px`;
    }
  };

  // book now menu logic Start
  navbarTabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const buttonText = button.querySelector(".navbar__tab-text-width");
      const selectedIndex = Number(button.getAttribute("data-tab-number"));
      const buttonPosition = buttonText.offsetLeft;

      navbarTabButtons.forEach((tab) => {
        if (tab !== button) {
          tab.classList.remove("active");
        }
      });

      button.classList.add("active");

      navbarTabThumb.style.transform = `translateX(${buttonPosition}px)`;
      setTabThumbWidth(buttonText);

      navbarTabs?.forEach((content) => {
        const tabIndex = Number(content.getAttribute("data-tab-number"));

        if (
          content.classList.contains("currentItem") &&
          selectedIndex !== tabIndex
        ) {
          content.classList.add("transitioningOut");
          content.classList.remove("currentItem");

          // Remove transitioning class after the transition ends
          content.addEventListener(
            "transitionend",
            function handleTransitionEnd() {
              content.classList.remove("transitioningOut");
              content.removeEventListener("transitionend", handleTransitionEnd);
            }
          );
        }

        if (selectedIndex === tabIndex) {
          content.classList.add("currentItem");
          content.classList.remove("nextItem", "prevItem");
        } else if (selectedIndex > tabIndex) {
          content.classList.add("prevItem");
          content.classList.remove("currentItem", "nextItem");
        } else {
          content.classList.add("nextItem");
          content.classList.remove("currentItem", "prevItem");
        }
      });
    });
  });

  // Function to update padding-left of searchMenuWrapper
  function updateSearchMenuPadding() {
    const marginRight = window.getComputedStyle(navbarContainer).marginRight;
    searchMenuWrapper.style.paddingRight = marginRight;
  }

  // Initial padding adjustment
  updateSearchMenuPadding();

  // Resize listener to adjust padding on window resize
  window.addEventListener("resize", updateSearchMenuPadding);

  menuTrigger.addEventListener("click", () => {
    if (document.body.classList.contains("navigation-open")) {
      closeNavMenu(menuWrapper);
    } else {
      closeNavMenu(searchMenuWrapper);
      openNavMenu(menuWrapper);
    }
  });

  const openBookMenu = () => {
    closeNavMenu(menuWrapper);
    searchMenuWrapper.classList.remove("is-search-menu");
    searchMenuWrapper.classList.add("is-book-menu");
    openNavMenu(searchMenuWrapper);

    let currentTab;
    navbarTabButtons.forEach((button) => {
      if (button?.classList?.contains("active")) {
        currentTab = button;
      }
    });

    setTabThumbWidth(currentTab ? currentTab : navbarTabButtons[0]);
  };

  bookNowButton?.addEventListener("click", () => {
    openBookMenu();
  });

  bookNowButtonMobile?.addEventListener("click", (e) => {
    openBookMenu();
  });

  searchTrigger.addEventListener("click", () => {
    searchMenuWrapper.classList.remove("is-book-menu");
    searchMenuWrapper.classList.add("is-search-menu");
    closeNavMenu(menuWrapper);
    openNavMenu(searchMenuWrapper);
    const input = searchMenuWrapper.querySelector(".navbar__search-input");
    if (input) {
      input.focus();
    }
  });

  closeButton?.addEventListener("click", () => {
    closeNavMenu(menuWrapper);
  });

  searchCloseButton.addEventListener("click", () => {
    closeNavMenu(searchMenuWrapper);
  });

  searchMenuWrapper.addEventListener("click", (e) => {
    if (e.target.closest(".navbar__search-container")) {
      return;
    }

    closeNavMenu(searchMenuWrapper);
  });

  closeSubMenuButton.addEventListener("click", () => {
    const activeParent = document.querySelectorAll(".menu-item.active");
    const openMenu = document.querySelectorAll(".sub-menu.active");

    openMenu?.forEach((menu) => {
      closeSubMenu(menu);
    });

    activeParent?.forEach((item) => {
      item.classList.remove("active");
    });
  });

  // Detect click outside search menu if so, close it
  document.addEventListener("click", (e) => {
    if (
      searchMenuWrapper.classList.contains("active") &&
      !searchMenuWrapper.contains(e.target) &&
      !searchTrigger.contains(e.target) &&
      !bookNowButtonMobile.contains(e.target) &&
      !bookNowButton.contains(e.target)
    ) {
      closeNavMenu(searchMenuWrapper);
    }
  });

  // close main menu on Esc key press
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeNavMenu(menuWrapper);
      closeNavMenu(searchMenuWrapper);
    }
  });

  subMenuTriggers.forEach((subMenuTrigger) => {
    subMenuTrigger.addEventListener("click", (e) => {
      // Second-level handling start. Under a .sub-menu
      if (e.currentTarget.closest(".sub-menu")) {
        // This should be a click-through link on mobile
        e.preventDefault();
        const menuItem = e.currentTarget.closest(".menu-item-has-children");
        const isActive = menuItem.classList.contains("active");
        if (!isActive) {
          openSubMenu(menuItem);
        } else {
          const menu = menuItem?.querySelector(".sub-menu");
          menuItem?.classList?.remove("active");
          menu?.classList?.remove("active");
        }
        return;
      }

      e.preventDefault();

      const menuItem = e.currentTarget.closest(".menu-item-has-children");
      const otherMenuItemsHaveChildren =
        menuItem.parentElement.querySelectorAll(
          ".menu-item-has-children.active"
        );
      const isActive = menuItem.classList.contains("active");

      otherMenuItemsHaveChildren.forEach((other) => {
        closeSubMenu(other);
      });

      if (!isActive) {
        openSubMenu(menuItem);
      }
    });
  });

  const bodyOffset = document.body.getBoundingClientRect();
  if (bodyOffset.top < 0) {
    header.classList.add("scrolled-up");
  }

  searchForm.addEventListener("submit", (e) => {
    e.preventDefault();
    doSearch(e.currentTarget, 1);
  });

  const searchInput = searchForm.querySelector(".navbar__search-input");
  searchInput.addEventListener(
    "input",
    debounce((e) => {
      doSearch(searchInput.closest(".navbar__search-form"), 1);
    }, 700)
  );

  searchInput.addEventListener(
    "change",
    debounce((e) => {
      doSearch(searchInput.closest(".navbar__search-form"), 1);
    }, 700)
  );
}

function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

function openSubMenu(menuItem) {
  document.body.classList.add("navigation-submenu-open");
  menuItem.classList.add("active");
  menuItem.querySelector(".sub-menu").classList.add("active");
  // NEW: Disable scrolling when submenu is open
  disableMainScroll();

  const subMenu = menuItem.closest(".sub-menu");
  if (subMenu) {
    subMenu.classList.add("has-sub-menu-open");
  }
}

function closeSubMenu(menuItem) {
  document.body.classList.remove("navigation-submenu-open");
  menuItem.classList.remove("active");
  menuItem?.querySelector(".sub-menu")?.classList?.remove("active");
  menuItem?.querySelector(".sub-menu")?.classList?.remove("has-sub-menu-open");
  // NEW: Check if no other menus are open before enabling scroll
  if (
    !document.body.classList.contains("navigation-open") &&
    !document.body.classList.contains("navigation-search-open")
  ) {
    enableMainScroll();
  }

  let transitionEndHandler = null;
  const subMenu = menuItem?.closest(".sub-menu");

  if (subMenu) {
    transitionEndHandler = () => {
      subMenu?.classList?.remove("has-sub-menu-open");
      subMenu.removeEventListener("transitionend", transitionEndHandler);
    };

    subMenu.addEventListener("transitionend", transitionEndHandler);
  }
}

function openNavMenu(menuWrapper) {
  menuWrapper.classList.add("active");
  document.body.classList.add("navigation-open");
  // NEW: Disable scrolling when menu is open
  disableMainScroll();

  if (menuWrapper.classList.contains("navbar__menu-wrapper")) {
    return;
  } else {
    document.body.classList.add("navigation-search-open");
  }
}

function closeNavMenu(menuWrapper) {
  menuWrapper.classList.remove("active");
  document.body.classList.remove("navigation-open");
  document.body.classList.remove("navigation-search-open");
  // NEW: Enable scrolling when all menus are closed
  enableMainScroll();

  const menuItemsHaveChildren = menuWrapper.querySelectorAll(
    ".menu-item-has-children.active"
  );

  menuItemsHaveChildren.forEach((menuItem) => {
    closeSubMenu(menuItem);
  });
}

function doSearch(form, page) {
  const params = new URLSearchParams(new FormData(form));
  const url = new URL(fg_theme.ajax_url);
  const searchResultWrapper = form.parentElement.querySelector(
    ".search__result-wrapper"
  );

  url.searchParams.append("action", "fg_search_api");
  url.searchParams.append("paged", page);

  Array.from(params.entries()).forEach(([key, value]) => {
    url.searchParams.append(key, value);
  });

  searchResultWrapper.classList.add("search__result-wrapper--loading");
  form.classList.add("search__result-wrapper--loading");

  fetch(url)
    .then((resp) => {
      return resp.json();
    })
    .then(({ html }) => {
      searchResultWrapper.innerHTML = html;
      addSearchResultEvents(searchResultWrapper, form);
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() => {
      searchResultWrapper.classList.remove("search__result-wrapper--loading");
      form.classList.remove("search__result-wrapper--loading");
    });
}

function addSearchResultEvents(wrapper, form) {
  const prev = wrapper.querySelector(".search__prev");
  const next = wrapper.querySelector(".search__next");
  const pageNavigate = (e) => {
    doSearch(form, e.currentTarget.dataset.page);
  };

  prev.addEventListener("click", pageNavigate);
  next.addEventListener("click", pageNavigate);
}

if (document.readyState !== "loading") {
  initializeNavbar();
} else {
  document.addEventListener("DOMContentLoaded", initializeNavbar);
}
